export default __webpack_public_path__ + "static/media/tri.e20e8a82.jpg";